$(document).on('turbolinks:load', function() {
  if(document.location.pathname.match(/^\/new$/)){
    $('input.icheck').iCheck({
      checkboxClass: 'icheckbox_square-blue',
      radioClass: 'iradio_square-blue'
    });
  }
});
